export default "__VITE_ASSET__DqHIXkbH__"